module.exports = __webpack_public_path__ + "static/media/coffee-machine.0fb72324.webp";